import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import SearchForm from "../../components/SearchForm";
import Dropzone from "../../components/Dropzone";
import { getToken, URL } from "../../utils";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberInput from "../../components/NumberInput";

function Category() {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  // const [selectedProductId, setSelectedProductId] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentCategory, setCurrentCategory] = useState({});
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const { pdv_id, id } = useParams();
  const navigate = useNavigate();
  const token = getToken();
  const [total_art, setTotalArt] = useState(0);

  // État pour le mode édition
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingProductId, setEditingProductId] = useState(null);

  // État pour le modal d'erreur
  const [errorModal, setErrorModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    type: "error", // "error", "auth", "validation"
    suggestions: [],
  });

  const [newProduct, setNewProduct] = useState({
    nom: "",
    nom_categorie: parseInt(id),
    unite: "unite",
    seuil: "",
    quantite: "",
    prix_achat: 0,
    prix_vente_emporte: 0,
    prix_vente_sur_place: 0,
    nom_magasin: parseInt(pdv_id),
  });

  const [openContextMenuId, setOpenContextMenuId] = useState(null);

  useEffect(() => {
    fetchAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fonction de recherche
  const handleSearch = (query) => {
    setSearchQuery(query);
    if (!query.trim()) {
      setFilteredData(data.stock_items || []);
    } else {
      const filtered = (data.stock_items || []).filter((item) =>
        item.nom.toLowerCase().includes(query.toLowerCase()),
      );
      setFilteredData(filtered);
    }
  };

  // Mettre à jour filteredData quand data change
  useEffect(() => {
    setFilteredData(data.stock_items || []);
  }, [data]);

  // Gestionnaire pour fermer le menu contextuel quand on clique ailleurs
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openContextMenuId &&
        !event.target.closest(".context-menu-container")
      ) {
        setOpenContextMenuId(null);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openContextMenuId]);

  const fetchAllData = async () => {
    setLoading(true); // Activer l'état de chargement
    try {
      // Regrouper les appels API avec Promise.all
      const [categoryResponse, productsResponse, quantityResponse] =
        await Promise.all([
          axios.get(URL + `Magasins/category-detail/${id}`, {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }),
          axios.get(
            URL + `Magasins/product-by-category/${pdv_id}/categories/${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          ),
          axios.get(URL + `Magasins/categories-articles-nbre/${id}`, {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }),
        ]);

      // Mettre à jour le total d'articles
      setTotalArt(quantityResponse.data.total_art);

      // Mettre à jour les états avec les réponses
      setCurrentCategory(categoryResponse.data);
      setData(productsResponse.data);
      // toast.success("Données chargées avec succès !");
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer les erreurs
      setValidationErrors(
        error.response?.data?.errors || {
          general: ["Une erreur s'est produite"],
        },
      );
      toast.error("Une erreur est survenue");
    } finally {
      setLoading(false); // Désactiver l'état de chargement
    }
  };

  const handleAddProduct = (e) => {
    e.preventDefault();
    if (
      newProduct.nom &&
      newProduct.quantite &&
      newProduct.seuil &&
      newProduct.unite &&
      newProduct.prix_vente_emporte &&
      newProduct.prix_vente_sur_place
    ) {
      if (isEditMode) {
        submitUpdate();
      } else {
        submitData();
      }
    } else {
      toast.error("Veuillez remplir tous les champs requis");
    }
  };

  const submitData = async () => {
    // Verifier que le seuil est inferieur a la quantite
    if (parseInt(newProduct.seuil) > parseInt(newProduct.quantite)) {
      toast.error("Le seuil ne peut pas être supérieur à la quantité");
      return;
    }

    try {
      setLoading(true);
      await axios.post(URL + "Magasins/create-product", newProduct, {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Produit ajouté avec succès");
      resetFields();
      fetchAllData(); // Recharger les données après l'ajout
    } catch (error) {
      handleApiError(error, "l'ajout du produit");
    } finally {
      setLoading(false);
    }
  };

  const resetFields = () => {
    setNewProduct({
      nom: "",
      quantite: "",
      seuil: "",
      unite: "unite",
      prix_achat: 0,
      prix_vente_emporte: 0,
      prix_vente_sur_place: 0,
      nom_magasin: pdv_id,
      nom_categorie: id,
    });
    setIsEditMode(false);
    setEditingProductId(null);
    setValidationErrors({});
  };

  const handleOpenDeleteModal = (id) => {
    // setSelectedProductId(id);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    // setSelectedProductId(null);
    setOpenDeleteModal(false);
  };

  const handleDelete = () => {
    // Logique de suppression ici
    handleCloseDeleteModal();
  };

  const handleOpenContextMenu = (id) => {
    setOpenContextMenuId(openContextMenuId === id ? null : id);
  };

  // Fonction pour gérer les erreurs API
  const handleApiError = (error, action) => {
    console.error(`Erreur lors de ${action}:`, error);
    const status = error.response?.status;
    const errorData = error.response?.data;

    if (status === 401 || status === 403) {
      setErrorModal({
        isOpen: true,
        title: status === 401 ? "Session expirée" : "Accès non autorisé",
        message:
          status === 401
            ? "Votre session a expiré ou vous n'êtes plus connecté."
            : "Vous n'avez pas les permissions nécessaires pour effectuer cette action.",
        type: "auth",
        suggestions: [
          "Rechargez la page pour actualiser votre session",
          "Vérifiez que vous êtes toujours connecté",
          "Reconnectez-vous si nécessaire",
        ],
      });
    } else if (status === 400) {
      const errorMessage =
        errorData?.error || errorData?.message || `Erreur lors de ${action}`;

      // Si ce sont des erreurs de validation de champs, les afficher
      if (
        errorData &&
        typeof errorData === "object" &&
        !errorData.error &&
        !errorData.message
      ) {
        setValidationErrors(errorData);
      }

      setErrorModal({
        isOpen: true,
        title: "Erreur de validation",
        message: errorMessage,
        type: "validation",
        suggestions: [
          "Vérifiez que tous les champs obligatoires sont remplis",
          "Assurez-vous que les valeurs saisies sont correctes",
          "Le seuil doit être inférieur à la quantité",
        ],
      });
    } else if (status === 404) {
      setErrorModal({
        isOpen: true,
        title: "Ressource introuvable",
        message:
          "Le produit que vous essayez de modifier n'existe pas ou a été supprimé.",
        type: "error",
        suggestions: [
          "Rechargez la page pour actualiser la liste des produits",
          "Le produit a peut-être été supprimé par un autre utilisateur",
        ],
      });
    } else if (status >= 500) {
      setErrorModal({
        isOpen: true,
        title: "Erreur serveur",
        message:
          "Une erreur s'est produite sur le serveur. Veuillez réessayer plus tard.",
        type: "error",
        suggestions: [
          "Attendez quelques instants et réessayez",
          "Si le problème persiste, contactez le support technique",
        ],
      });
    } else {
      const errorMessage =
        errorData?.error ||
        errorData?.message ||
        error.message ||
        `Une erreur inattendue s'est produite lors de ${action}`;

      setErrorModal({
        isOpen: true,
        title: "Erreur",
        message: errorMessage,
        type: "error",
        suggestions: [
          "Vérifiez votre connexion internet",
          "Rechargez la page et réessayez",
        ],
      });
    }
  };

  // Fonction pour fermer le modal d'erreur
  const closeErrorModal = () => {
    setErrorModal((prev) => ({ ...prev, isOpen: false }));
  };

  // Fonction pour recharger la page
  const handleReloadPage = () => {
    window.location.reload();
  };

  // Fonction pour passer en mode édition
  const handleEditProduct = (item) => {
    setNewProduct({
      nom: item.nom,
      quantite: item.quantite,
      seuil: item.seuil,
      unite: item.unite || "unite",
      prix_achat: item.prix_achat || 0,
      prix_vente_emporte: item.prix_vente_emporte || 0,
      prix_vente_sur_place: item.prix_vente_sur_place || 0,
      nom_magasin: parseInt(pdv_id),
      nom_categorie: parseInt(id),
    });
    setIsEditMode(true);
    setEditingProductId(item.id);
    setOpenContextMenuId(null);
    setValidationErrors({});

    // Scroll vers le formulaire
    document
      .getElementById("product-form")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  // Fonction pour soumettre la mise à jour
  const submitUpdate = async () => {
    if (parseInt(newProduct.seuil) > parseInt(newProduct.quantite)) {
      toast.error("Le seuil ne peut pas être supérieur à la quantité");
      return;
    }

    try {
      setLoading(true);
      await axios.put(
        URL + `Magasins/update-product/${editingProductId}`,
        newProduct,
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      toast.success("Produit modifié avec succès");
      resetFields();
      fetchAllData();
    } catch (error) {
      handleApiError(error, "la modification du produit");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500"></div>
          <p className="text-gray-600 font-medium">Chargement en cours...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer />

      {/* Modal d'erreur personnalisé */}
      {errorModal.isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden animate-in fade-in zoom-in duration-200">
            {/* Header du modal */}
            <div
              className={`p-6 ${
                errorModal.type === "auth"
                  ? "bg-gradient-to-r from-orange-500 to-amber-500"
                  : errorModal.type === "validation"
                    ? "bg-gradient-to-r from-yellow-500 to-orange-500"
                    : "bg-gradient-to-r from-red-500 to-rose-600"
              }`}
            >
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  {errorModal.type === "auth" ? (
                    <svg
                      className="w-8 h-8 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      />
                    </svg>
                  ) : errorModal.type === "validation" ? (
                    <svg
                      className="w-8 h-8 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-8 h-8 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  )}
                </div>
                <h3 className="ml-3 text-xl font-bold text-white">
                  {errorModal.title}
                </h3>
              </div>
            </div>

            {/* Corps du modal */}
            <div className="p-6">
              <p className="text-gray-700 text-base mb-4">
                {errorModal.message}
              </p>

              {errorModal.suggestions.length > 0 && (
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-sm font-semibold text-gray-600 mb-2">
                    Suggestions :
                  </p>
                  <ul className="space-y-2">
                    {errorModal.suggestions.map((suggestion, index) => (
                      <li
                        key={index}
                        className="text-sm text-gray-600 flex items-start"
                      >
                        <span className="text-amber-500 mr-2">•</span>
                        {suggestion}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Footer du modal avec boutons d'action */}
            <div className="px-6 pb-6 flex flex-col sm:flex-row gap-3">
              {errorModal.type === "auth" ? (
                <>
                  <button
                    onClick={handleReloadPage}
                    className="flex-1 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white py-3 px-4 rounded-xl font-semibold transition-all duration-200 flex items-center justify-center"
                  >
                    <svg
                      className="w-5 h-5 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                      />
                    </svg>
                    Recharger la page
                  </button>
                  <button
                    onClick={() => (window.location.href = "/login")}
                    className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 px-4 rounded-xl font-semibold transition-all duration-200"
                  >
                    Se reconnecter
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={closeErrorModal}
                    className="flex-1 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white py-3 px-4 rounded-xl font-semibold transition-all duration-200"
                  >
                    Compris
                  </button>
                  <button
                    onClick={handleReloadPage}
                    className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 px-4 rounded-xl font-semibold transition-all duration-200"
                  >
                    Recharger la page
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="shadow-md bg-white p-4 flex justify-between items-center sticky top-16 z-40">
        <SearchForm
          placeholder="Rechercher un produit"
          onSearch={handleSearch}
        />
      </div>

      {/* Form Section */}
      <div className="m-4 rounded-md flex gap-4 max-md:flex-col">
        <div className="flex-grow md:flex-[2] bg-white rounded shadow-md ">
          <img
            src={
              currentCategory.photo
                ? `${URL}media/${currentCategory.photo}`
                : "https://i.pinimg.com/736x/78/16/50/781650001b4c216959d8d5bcac8bb2e5.jpg"
            }
            alt="Description de l'image"
            className="h-56 w-full object-cover rounded-t-lg"
          />
          <div className="p-4">
            <h1 className="text-2xl flex justify-between items-center">
              {currentCategory.nom}
              <span className="flex items-center gap-1 text-sm font-medium text-gray-700">
                <svg
                  className="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
                {total_art} articles
              </span>
            </h1>
            {/* Product Table Section */}
            <div className="my-4 rounded-md space-y-5">
              <h2 className="text-lg font-medium mb-4">Produits en stock</h2>
              <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
                <table className="min-w-full text-sm text-left text-gray-500">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 border-b border-gray-200">
                    <tr>
                      <th
                        scope="col"
                        className="px-2 py-3 text-center whitespace-nowrap"
                      >
                        ID
                      </th>
                      <th scope="col" className="px-4 py-3 whitespace-nowrap">
                        Nom du produit
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3 text-center whitespace-nowrap"
                      >
                        Stock
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3 text-center whitespace-nowrap"
                      >
                        Seuil
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3 text-center whitespace-nowrap"
                      >
                        Prix achat
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3 text-center whitespace-nowrap"
                      >
                        Prix vente (emporté)
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3 text-center whitespace-nowrap"
                      >
                        Prix vente (sur place)
                      </th>
                      <th
                        scope="col"
                        className="px-2 py-3 text-center whitespace-nowrap"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredData && filteredData.length > 0 ? (
                      filteredData.map((item) => (
                        <tr
                          className="hover:bg-gray-50 transition-colors duration-150 relative"
                          key={item.id}
                        >
                          <td className="px-2 py-4 font-medium text-gray-900 text-center">
                            #{item.id}
                          </td>
                          <td className="px-4 py-4">
                            <div
                              className="font-medium text-gray-900 truncate"
                              title={item.nom}
                            >
                              {item.nom}
                            </div>
                          </td>
                          <td className="px-3 py-4 text-center">
                            <span
                              className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                                item.quantite <= item.seuil
                                  ? "bg-red-100 text-red-800"
                                  : item.quantite <= item.seuil * 1.5
                                    ? "bg-yellow-100 text-yellow-800"
                                    : "bg-green-100 text-green-800"
                              }`}
                            >
                              {item.quantite}
                            </span>
                          </td>
                          <td className="px-3 py-4 text-center">
                            <div className="flex items-center justify-center gap-1">
                              <svg
                                className="w-3 h-3 text-amber-500"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path d="M17.133 12.632v-1.8a5.406 5.406 0 0 0-4.154-5.262.955.955 0 0 0 .021-.106V3.1a1 1 0 0 0-2 0v2.364a.955.955 0 0 0 .021.106 5.406 5.406 0 0 0-4.154 5.262v1.8C6.867 15.018 5 15.614 5 16.807 5 17.4 5 18 5.538 18h12.924C19 18 19 17.4 19 16.807c0-1.193-1.867-1.789-1.867-4.175ZM8.823 19a3.453 3.453 0 0 0 6.354 0H8.823Z" />
                              </svg>
                              <span className="font-medium text-gray-900 text-xs">
                                {item.seuil}
                              </span>
                            </div>
                          </td>
                          <td className="px-3 py-4 text-center">
                            {item.prix_achat}
                          </td>
                          <td className="px-3 py-4 text-center">
                            {item.prix_vente_emporte}
                          </td>
                          <td className="px-3 py-4 text-center">
                            {item.prix_vente_sur_place}
                          </td>
                          <td className="px-2 py-4 text-center">
                            <div className="relative context-menu-container">
                              <button
                                onClick={() => handleOpenContextMenu(item.id)}
                                className="p-1 rounded-full hover:bg-gray-100 transition-colors duration-150"
                                title="Actions"
                              >
                                <svg
                                  className="w-5 h-5 text-gray-500"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeWidth="2"
                                    d="M6 12h.01m6 0h.01m5.99 0h.01"
                                  />
                                </svg>
                              </button>

                              {/* Menu contextuel */}
                              <div
                                className={`absolute top-full right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-50 ${
                                  openContextMenuId === item.id
                                    ? "block"
                                    : "hidden"
                                }`}
                                style={{ minWidth: "120px" }}
                              >
                                <div className="py-1">
                                  <button
                                    onClick={() => {
                                      setOpenContextMenuId(null);
                                      navigate(
                                        `/stock/edit-product/${item.id}`,
                                      );
                                    }}
                                    className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-150"
                                  >
                                    <svg
                                      className="w-4 h-4"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
                                      />
                                    </svg>
                                    Modifier
                                  </button>
                                  <button
                                    onClick={() => {
                                      handleOpenDeleteModal(item.id);
                                      setOpenContextMenuId(null);
                                    }}
                                    className="flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150"
                                  >
                                    <svg
                                      className="w-4 h-4"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                                      />
                                    </svg>
                                    Supprimer
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="px-6 py-8 text-center">
                          <div className="flex flex-col items-center justify-center space-y-3">
                            <svg
                              className="w-12 h-12 text-gray-400"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1"
                                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                              />
                            </svg>
                            <div className="text-gray-500">
                              <p className="font-medium">
                                Aucun produit trouvé
                              </p>
                              <p className="text-sm">
                                Ajoutez votre premier produit pour commencer
                              </p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div
          id="product-form"
          className="flex-grow md:flex-1 bg-white p-4 rounded shadow-md"
        >
          <h2 className="text-lg font-medium mb-4 flex justify-between items-center">
            {isEditMode ? (
              <span className="flex items-center gap-2">
                <span className="inline-flex items-center justify-center w-6 h-6 bg-amber-100 rounded-full">
                  <svg
                    className="w-4 h-4 text-amber-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
                    />
                  </svg>
                </span>
                Modifier le produit
              </span>
            ) : (
              "Ajouter un nouveau produit"
            )}
            <button
              type="button"
              className="flex items-center justify-center p-2 rounded-full h-12 w-12 hover:bg-gray-100 transition-colors"
              onClick={resetFields}
              title={
                isEditMode
                  ? "Annuler la modification"
                  : "Réinitialiser le formulaire"
              }
            >
              <svg
                className="w-6 h-6 text-gray-600"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"
                />
              </svg>
            </button>
          </h2>

          <form onSubmit={handleAddProduct} className="space-y-4 text-sm">
            <div className="space-y-1">
              <label htmlFor="nom">Nom</label>
              <input
                type="text"
                id="nom"
                value={newProduct.nom}
                onChange={(e) =>
                  setNewProduct({ ...newProduct, nom: e.target.value })
                }
                className="w-full border p-2 rounded"
              />
              {validationErrors.nom && (
                <div className="text-red-500 text-xs">
                  {validationErrors.nom[0]}
                </div>
              )}
            </div>
            <div className="space-y-1">
              <label htmlFor="unite">Unité de mesure</label>
              <input
                type="text"
                className="w-full border p-2 rounded"
                value={newProduct.unite}
                disabled
              />
              {validationErrors.unite && (
                <div className="text-red-500 text-xs">
                  {validationErrors.unite[0]}
                </div>
              )}
            </div>
            <div className="flex gap-4">
              <div className="flex-grow space-y-1">
                <label htmlFor="quantite">Quantité initiale</label>
                <NumberInput
                  id="quantite"
                  name="quantite"
                  value={newProduct.quantite}
                  onChange={(value) =>
                    setNewProduct({
                      ...newProduct,
                      quantite: value,
                    })
                  }
                  className="w-full border p-2 rounded"
                />

                {validationErrors.quantite && (
                  <div className="text-red-500 text-xs">
                    {validationErrors.quantite[0]}
                  </div>
                )}
              </div>
              <div className="flex-grow space-y-1">
                <label htmlFor="seuil">Quantité seuil</label>
                <NumberInput
                  id="seuil"
                  name="seuil"
                  value={newProduct.seuil}
                  onChange={(value) =>
                    setNewProduct({
                      ...newProduct,
                      seuil: value,
                    })
                  }
                  className="w-full border p-2 rounded"
                />

                {validationErrors.seuil && (
                  <div className="text-red-500 text-xs">
                    {validationErrors.seuil[0]}
                  </div>
                )}
              </div>
            </div>
            <div className="space-y-1">
              <label htmlFor="prix_achat">Prix d'achat</label>
              <NumberInput
                id="prix_achat"
                name="prix_achat"
                value={newProduct.prix_achat}
                onChange={(value) =>
                  setNewProduct({
                    ...newProduct,
                    prix_achat: value,
                  })
                }
                className="w-full border p-2 rounded"
              />

              {validationErrors.prix_achat && (
                <div className="text-red-500 text-xs">
                  {validationErrors.prix_achat[0]}
                </div>
              )}
            </div>
            <div className="p-2 border rounded-md bg-gray-100">
              <label className="text-sm font-medium">Prix de vente</label>
              <p className="text-xs text-gray-500 mb-2">
                Remplissez les deux prix de vente du produit
                <br />
                Le prix de vente sur place est le prix du produit dans le point
                de vente et le prix de vente emporté est le prix du produit à
                emporter.
              </p>
              <div className="flex gap-4">
                <div className="flex-grow space-y-1">
                  <label htmlFor="prix_vente_sur_place">Sur place</label>
                  <NumberInput
                    id="prix_vente_sur_place"
                    name="prix_vente_sur_place"
                    value={newProduct.prix_vente_sur_place}
                    onChange={(value) =>
                      setNewProduct({
                        ...newProduct,
                        prix_vente_sur_place: value,
                      })
                    }
                    className="w-full border p-2 rounded"
                  />
                  {validationErrors.prix_vente_sur_place && (
                    <div className="text-red-500 text-xs">
                      {validationErrors.prix_vente_sur_place[0]}
                    </div>
                  )}
                </div>
                <div className="flex-grow space-y-1">
                  <label htmlFor="prix_vente_emporte">Emporté</label>
                  <NumberInput
                    id="prix_vente_emporte"
                    name="prix_vente_emporte"
                    value={newProduct.prix_vente_emporte}
                    onChange={(value) =>
                      setNewProduct({
                        ...newProduct,
                        prix_vente_emporte: value,
                      })
                    }
                    className="w-full border p-2 rounded"
                  />

                  {validationErrors.prix_vente_emporte && (
                    <div className="text-red-500 text-xs">
                      {validationErrors.prix_vente_emporte[0]}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Dropzone />
            <button
              type="submit"
              className={`w-full text-white p-2 rounded flex items-center justify-center ${
                isEditMode
                  ? "bg-blue-500 hover:bg-blue-600"
                  : "bg-amber-500 hover:bg-amber-600"
              }`}
              disabled={loading}
            >
              {loading ? (
                <div className="h-5 w-5 border-2 border-t-2 border-t-transparent rounded-full animate-spin"></div>
              ) : isEditMode ? (
                "Enregistrer les modifications"
              ) : (
                "Ajouter"
              )}
            </button>
            {isEditMode && (
              <button
                type="button"
                onClick={resetFields}
                className="w-full bg-gray-100 text-gray-700 p-2 rounded hover:bg-gray-200 flex items-center justify-center mt-2"
              >
                Annuler
              </button>
            )}
          </form>
        </div>
      </div>

      {openDeleteModal && (
        <div className="fixed top-0 left-0 inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute top-0 left-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm cursor-pointer"
            onClick={handleCloseDeleteModal} // Ajout d'un gestionnaire d'événements pour fermer le modal
          ></div>
          <div className="relative p-4 w-full max-w-md max-h-full">
            <div className="relative bg-white rounded-lg shadow">
              <button
                type="button"
                className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                onClick={handleCloseDeleteModal} // Ajout du gestionnaire d'événements pour fermer le modal
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
              <div className="p-4 md:p-5">
                <h3 className="mb-5 text-xl font-semibold flex items-center gap-4">
                  <svg
                    className="h-8 w-8 text-red-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                    />
                  </svg>
                  Supprimer ce point de vente
                </h3>
                <p className="mb-5 text-lg font-normal text-gray-500">
                  Êtes-vous sûr de vouloir supprimer ce point de vente ? Cette
                  action est irréversible.
                </p>
                <div className="grid grid-cols-2 gap-4">
                  <button
                    type="button"
                    className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm items-center px-5 py-2.5 text-center"
                    onClick={handleDelete} // Ajout du gestionnaire d'événements pour la suppression
                  >
                    Supprimer
                  </button>
                  <button
                    type="button"
                    className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-amber-500 focus:z-10 focus:ring-4 focus:ring-gray-100"
                    onClick={handleCloseDeleteModal} // Ajout du gestionnaire d'événements pour fermer le modal
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Category;
